import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentStatusIds, scheduleCodeEnum, assessmentTypeId } from '@configs/assessment.config';
import { TranslateService } from '@ngx-translate/core';
import { AssessmentService } from '@services/assessment.service';
import { ConfigService } from '@services/config.service';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuestionInfo } from 'src/app/reports/detailed-test-report/detailed-test-report.component';

@Component({
  selector: 'app-patient-assessment-details',
  templateUrl: './patient-assessment-details.component.html',
  styleUrls: ['./patient-assessment-details.component.scss']
})
export class PatientAssessmentDetailsComponent implements OnInit {
  assessmentStatusList: any;
  assessmentTypeList: any;
  assessmentStatus: number = 0;
  assessmentName: any = '';
  assessmentType: number = 0;
  AssessmentDetails: any = [];

  dataSource: any;
  patientId: any;
  displayedColumns: string[] = ['Assessmentname', 'Assessmentstatus', 'Assessmenttype', 'action'];
  reportDisplayedColumns: string[] = ['Question', 'patientResponse'];
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    if(this.dataSource){
      this.dataSource.paginator = paginator;
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  unsubscribe: Subject<void> = new Subject<void>();
  headerData: any;
  isBacked: boolean = false;
  collectionId: any;
  testDetails: any[] = [];
  filteredDataSourceItem: any;
  spansBackup: any[];
  QuestionInfoList: Array<QuestionInfo> = [];
  spans: any;
  printdataSource: any;
  isReportView: boolean = false;
  currentPageSize: number = 10;
  currentPage: number = 1;
  totalPage: number = 1;
  fromIndex: number = 1;
  toIndex: number = 1;
  reportAssessmentName: any;
  totalScore: any;
  isDetailedTestReport: boolean = false;
  selectedAssessmentData: any;
  hideDiagnosis = false;
  interpretationValue: string;
  testResult: string;
  A1AssessmentStarted: any;
  isDatanotFound: boolean = false;
  AssessmentStatusIds: any;
  scheduleCodeEnum: any;
  assessmentTypeIdEnum: any;
  scoreColShown: boolean = false;
  optionsColShown: boolean = false;
  constructor(public AssessmentSer: AssessmentService, public activatedRoute: ActivatedRoute,
    public translate: TranslateService, public router: Router, public configService: ConfigService,
    public sanitizer: DomSanitizer,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
  ) {
    this.AssessmentStatusIds = AssessmentStatusIds;
    this.scheduleCodeEnum = scheduleCodeEnum;
    this.assessmentTypeIdEnum = assessmentTypeId;
    this.collectionId = JSON.parse(sessionStorage.getItem('defaultcollectionid'));

    document.onclick = (args: any) : void => {
      document.title = 'Simpliassess'
    }
  }

  ngOnInit(): void {
    this.patientId = this.activatedRoute.snapshot.paramMap.get('id');

    this.AssessmentSer.getAssessmentStatus().subscribe(data => {
      this.assessmentStatusList = data.data;
    });

    this.AssessmentSer.getPatientHeaderDetails(this.patientId, this.collectionId).subscribe(h =>{
      this.headerData = h.data;
    });

    this.AssessmentSer.GetAssessmentTypeMaster().subscribe(type =>{
      this.assessmentTypeList = type.data;
    });

    this.patientAssessment();
  }

  patientAssessment() {
    this.AssessmentSer.getPatientAssessments(this.patientId, this.collectionId).subscribe(data => {
      if (data.success) {
        if (data.data.length == 0) {
          this.isDatanotFound = true;
        } else {
          this.AssessmentDetails = data.data
          this.dataSource = new MatTableDataSource(data.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.isDatanotFound = false;
          this.A1AssessmentStarted = data.data.find(d => d.scheduleCode == scheduleCodeEnum.A1).assessmentStatusId;
          this.setPaginator();
        }
      }
    });
  }

  searchFilter() {
    this.AssessmentSer.getSearchPatientAssessments(this.patientId, this.assessmentName, this.assessmentStatus, this.assessmentType, this.collectionId).subscribe(data => {
      if (data.success) {
        // this.AssessmentDetails = data.data
        if (data.data.length == 0) {
          this.isDatanotFound = true;
        } else {
          this.dataSource = new MatTableDataSource(data.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.isDatanotFound = false;
          this.A1AssessmentStarted = data.data.find(d => d.scheduleCode == scheduleCodeEnum.A1).assessmentStatusId;
          this.setPaginator();
        }
      }
    });
  }

  resetFilter() {
    this.assessmentName = '';
    this.assessmentStatus = 0;
    this.assessmentType = 0;

    this.patientAssessment();
  }

  setPaginator(): void {
    setTimeout(() => {
      // ------Set translation for pagination------
      if(this.dataSource.paginator) {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.translate.stream([
          'assessment.assessmentDetails.pagination.pageLabel',
          'assessment.assessmentDetails.pagination.firstPage',
          'assessment.assessmentDetails.pagination.lastPage',
          'assessment.assessmentDetails.pagination.nextPage',
          'assessment.assessmentDetails.pagination.prevPage'
        ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
            this.dataSource.paginator._intl.itemsPerPageLabel = translation['assessment.assessmentDetails.pagination.pageLabel'];
            this.dataSource.paginator._intl.firstPageLabel = translation['assessment.assessmentDetails.pagination.firstPage'];
            this.dataSource.paginator._intl.lastPageLabel = translation['assessment.assessmentDetails.pagination.lastPage'];
            this.dataSource.paginator._intl.nextPageLabel = translation['assessment.assessmentDetails.pagination.nextPage'];
            this.dataSource.paginator._intl.previousPageLabel = translation['assessment.assessmentDetails.pagination.prevPage'];

            this.dataSource.paginator._intl.changes.next();
        });
      }
    });
  }

  onStartAssessment(row) {
    // if (row.scheduleCode  == scheduleCodeEnum.A5 || row.scheduleCode  == scheduleCodeEnum.A6 || row.scheduleCode  == scheduleCodeEnum.A7 || row.scheduleCode  == scheduleCodeEnum.A8) {
    //   let url = row.assessmentUrl.replace('https://drr.simpliassess.com', 'http://localhost:4200')
    //   window.open(row.assessmentUrl, '_blank');
    // } else {
    //   this.AssessmentSer.sendAssessmentUrl(row.patientid, row.assessmentName, row.assessmentStatusId, row.assessmentTypeId, row.scheduleCode, this.collectionId).subscribe((res) => {
    //     this.notificationService.success(res.message);
        let url = row.assessmentUrl.replace('https://drr.simpliassess.com', 'http://localhost:4200')
        window.open(row.assessmentUrl, '_blank');
    //   }, (error: any) => {
    //     this.webErrorService.handleAPIErrors(error, null, true, 'warn');
    //   });
    // }
  }

  onResumeAssessment(row) {
    // if (row.scheduleCode  == scheduleCodeEnum.A5 || row.scheduleCode  == scheduleCodeEnum.A6 || row.scheduleCode  == scheduleCodeEnum.A7 || row.scheduleCode  == scheduleCodeEnum.A8) {
    //   let url = row.assessmentUrl.replace('https://drr.simpliassess.com', 'http://localhost:4200')
    //   window.open(row.assessmentUrl, '_blank');
    // } else {
    //   this.AssessmentSer.sendAssessmentUrl(row.patientid, row.assessmentName, row.assessmentStatusId, row.assessmentTypeId, row.scheduleCode, this.collectionId).subscribe((res) => {
    //     this.notificationService.success(res.message);
        let url = row.assessmentUrl.replace('https://drr.simpliassess.com', 'http://localhost:4200')
        window.open(row.assessmentUrl, '_blank');
    //   }, (error: any) => {
    //     this.webErrorService.handleAPIErrors(error, null, true, 'warn');
    //   });
    // }
  }

  setInterpretationValue(scheduleCode) {
    if(scheduleCode === scheduleCodeEnum.A1){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value1A');
    } else if(scheduleCode === scheduleCodeEnum.A2){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value2A');
    } else if(scheduleCode === scheduleCodeEnum.A3){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value3APDF');
    } else if(scheduleCode === scheduleCodeEnum.A4){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value4A');
    } else if(scheduleCode === scheduleCodeEnum.A5){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value5A');
    } else if(scheduleCode === scheduleCodeEnum.A6){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value6A');
    } else if(scheduleCode === scheduleCodeEnum.A7){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value7A');
    } else if(scheduleCode === scheduleCodeEnum.A8){
      this.interpretationValue = this.translate.instant('reports.detailedTestReport.Value8A');
    } else {
      this.hideDiagnosis = true;
    }
    console.log(this.interpretationValue)
  }

  onDownloadReport(row) {
    if (row.scheduleCode != scheduleCodeEnum.A5 && row.scheduleCode != scheduleCodeEnum.A7 && row.scheduleCode != scheduleCodeEnum.A8) {
      let score = this.reportDisplayedColumns.find(c => c == 'score');
      if (!score) {
        this.reportDisplayedColumns.push('score');
        this.scoreColShown = true;
      }
    } else {
      let score = this.reportDisplayedColumns.find(c => c == 'score');
      if (score) {
        this.reportDisplayedColumns.splice(-1)
        this.scoreColShown = true;
      }
    }

    if (row.scheduleCode != scheduleCodeEnum.A5 && row.scheduleCode != scheduleCodeEnum.A8) {
      let option = this.reportDisplayedColumns.find(c => c == 'options');
      if (!option) {
        this.reportDisplayedColumns.splice(1, 0, 'options')
        this.optionsColShown = true;
      }
    } else {
      let optionIndex = this.reportDisplayedColumns.indexOf('options')
      if (optionIndex > -1) {
        this.reportDisplayedColumns.splice(optionIndex, 1)
        this.optionsColShown = true;
      }
    }

    this.AssessmentSer.getPatientAssessmentTestDetail(row.scheduleid, row.patientid).subscribe(async data => {
      this.testDetails = JSON.parse(JSON.stringify(await this.processResponseData(data)));
      this.mergeData();
      // this.setPaginator();

      this.reportAssessmentName = row.assessmentName;
      this.totalScore = data[0].totalScore;
      this.testResult = data[0].testResult;

      setTimeout(() => {
        document.title = this.headerData?.patientName + '_' + this.reportAssessmentName;
        window.print();
        window.onafterprint = function(){
          document.title = 'Simpliassess'
        }

        window.oncancel = function(){
          document.title = 'Simpliassess'
        }
      }, 0);
    });
    this.setInterpretationValue(row.scheduleCode)
  }

  onResendSMS(row) {
    this.AssessmentSer.sendAssessmentUrl(row.patientid, '', row.assessmentStatusId, row.assessmentTypeId, row.scheduleCode, this.collectionId).subscribe((res) => {

    });
  }

  processResponseData(res: Array<any>): Promise<Array<any>> {
    return new Promise(async (resolve) => {
      let responseData: Array<any> = [];

      // res.sort((a, b) => b.questionId - a.questionId || (b.orderby - a.orderby));

      let skipItemId: number;

      for (let index = 0; index < res.length; index++) {
        const row = res[index];
        if (row.questionId != skipItemId) {
          skipItemId = null;
          responseData.push(row);
        }
      }
      resolve(responseData);
    });
  }

  mergeData() {
    this.filteredDataSourceItem = JSON.parse(JSON.stringify(this.testDetails));

    this.cacheSpan('questionId', d => d.questionId);
    this.setPageData();
  }

  cacheSpan(key, accessor) {
    this.spansBackup = [];
    if (key == 'questionId') {
      this.QuestionInfoList = [];
    }
    for (let i = 0; i < this.filteredDataSourceItem.length;) {
      let currentValue = accessor(this.filteredDataSourceItem[i]);
      let count = 1;

      for (let j = i + 1; j < this.filteredDataSourceItem.length; j++) {
        if (currentValue != accessor(this.filteredDataSourceItem[j])) {
          break;
        }

        count++;
      }

      if (!this.spansBackup[i]) {
        this.spansBackup[i] = {};
      }

      this.spansBackup[i][key] = count;
      if (key == 'questionId') {
        const index = this.QuestionInfoList.length + 1;
        this.QuestionInfoList.push({
          index: index,
          fromIndex: i,
          toIndex: count == 1 ? i : i + (count - 1),
          classid: this.filteredDataSourceItem[i].questionId
        });
      }
      i += count;
    }

  }

  getRowSpan(col, index) {
    return this.spans[index] && this.spans[index][col];
  }

  setPageData() {
    this.printdataSource = new MatTableDataSource([]);
    this.spans = [];
    this.spans = this.spansBackup;
    this.printdataSource = new MatTableDataSource(this.filteredDataSourceItem);

    this.isReportView = true;
  }

  onViewReport(row) {
    sessionStorage.setItem('viewReport', 'true');
    this.AssessmentSer.patientDataFromAssessment.next({...row, headerData: this.headerData});
    this.router.navigate(["../../reports"], { relativeTo: this.activatedRoute });
  }

  back() {
    this.router.navigate(["../../assessments"], { relativeTo: this.activatedRoute });
  }
}
